module.exports = __webpack_public_path__ + "img/pick-left.61cd74f4.png";